/**
 * The variation SVG Root wrapper
 * @type {{}}
 */
const VARIATION_SVG_ATTRIBUTES = {
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

/**
 * The variation loading state background color
 * @type {String}
 */
const LOADING_BACKGROUND_COLOR = '#f5f5f5';

/**
 * The default variation viewbox config
 * @type {{crop: Boolean, gutters: Number}}
 */
const DEFAULT_VIEWBOX_CONFIG = {
    crop: true,
    gutters: 140
};

module.exports = {
    VARIATION_SVG_ATTRIBUTES,
    LOADING_BACKGROUND_COLOR,
    DEFAULT_VIEWBOX_CONFIG
};
